var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadsTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_3602109",
    clipPath: "url(#clip0_164_19845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3333 15.3333H1.66667C0.748 15.3333 0 14.5853 0 13.6667V2.33333C0 1.41466 0.748 0.666664 1.66667 0.666664H14.3333C15.252 0.666664 16 1.41466 16 2.33333V13.6667C16 14.5853 15.252 15.3333 14.3333 15.3333ZM1.66667 1.33333C1.11533 1.33333 0.666667 1.782 0.666667 2.33333V13.6667C0.666667 14.218 1.11533 14.6667 1.66667 14.6667H14.3333C14.8847 14.6667 15.3333 14.218 15.3333 13.6667V2.33333C15.3333 1.782 14.8847 1.33333 14.3333 1.33333H1.66667Z",
    fill: "#28303F",
    stroke: "#28303F",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.6667 5.33333H0.333333C0.149333 5.33333 0 5.184 0 5C0 4.816 0.149333 4.66666 0.333333 4.66666H15.6667C15.8507 4.66666 16 4.816 16 5C16 5.184 15.8507 5.33333 15.6667 5.33333Z",
    fill: "#28303F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6667 8.66667H0.333333C0.149333 8.66667 0 8.51733 0 8.33333C0 8.14933 0.149333 8 0.333333 8H15.6667C15.8507 8 16 8.14933 16 8.33333C16 8.51733 15.8507 8.66667 15.6667 8.66667Z",
    fill: "#28303F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.6667 12H0.333333C0.149333 12 0 11.8507 0 11.6667C0 11.4827 0.149333 11.3333 0.333333 11.3333H15.6667C15.8507 11.3333 16 11.4827 16 11.6667C16 11.8507 15.8507 12 15.6667 12Z",
    fill: "#28303F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.33333 15.3333C4.14933 15.3333 4 15.184 4 15V5C4 4.816 4.14933 4.66666 4.33333 4.66666C4.51733 4.66666 4.66667 4.816 4.66667 5V15C4.66667 15.184 4.51733 15.3333 4.33333 15.3333Z",
    fill: "#28303F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.00001 15.3333C7.81601 15.3333 7.66667 15.184 7.66667 15V5C7.66667 4.816 7.81601 4.66666 8.00001 4.66666C8.18401 4.66666 8.33334 4.816 8.33334 5V15C8.33334 15.184 8.18401 15.3333 8.00001 15.3333Z",
    fill: "#28303F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.6667 15.3333C11.4827 15.3333 11.3333 15.184 11.3333 15V5C11.3333 4.816 11.4827 4.66666 11.6667 4.66666C11.8507 4.66666 12 4.816 12 5V15C12 15.184 11.8507 15.3333 11.6667 15.3333Z",
    fill: "#28303F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_19845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsTable);
export default __webpack_public_path__ + "static/media/leads-table.cc1c259e9126c8719fe64362e65755a2.svg";
export { ForwardRef as ReactComponent };